import MultiSelect from "../multiSelect";
import Switch from "../switch";
import LocationsFilter from "../locationsFilter";

const filtersLookup = {
  "multi-select": MultiSelect,
  "multi-select-array": MultiSelect,
  boolean: Switch,
  "locations-autocomplete": LocationsFilter,
};

const Filter = ({ type, ...rest }) => {
  const FilterComponent = filtersLookup[type];
  if (!FilterComponent) return null;
  return <FilterComponent {...rest} />;
};

export default Filter;
